import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-20 bg-gradient-to-b from-[#0a0a0a] to-black text-white relative" data-testid="site-footer">
      <div className="absolute inset-0 bg-white/[0.03] backdrop-blur-xl border-t border-white/10 pointer-events-none" />
      <div className="relative sq-container py-20 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2">
          <div className="font-display text-3xl">SquireCouture</div>
          <p className="mt-4 text-sm text-white/70 max-w-sm">
            A digital atelier for the modern man. Bespoke tailoring, premium fabrics, ready-made essentials — crafted by hand, delivered to your door.
          </p>
          <div className="flex gap-3 mt-6">
            <a className="p-2 border border-white/30 hover:bg-squire-jeans hover:border-squire-jeans transition-colors" href="#" data-testid="footer-instagram"><Instagram size={16} /></a>
            <a className="p-2 border border-white/30 hover:bg-squire-jeans hover:border-squire-jeans transition-colors" href="#" data-testid="footer-facebook"><Facebook size={16} /></a>
            <a className="p-2 border border-white/30 hover:bg-squire-jeans hover:border-squire-jeans transition-colors" href="#" data-testid="footer-twitter"><Twitter size={16} /></a>
          </div>
        </div>
        <div>
          <div className="sq-eyebrow text-white/60 mb-4">Shop</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/fabrics" className="hover:text-squire-jeanslight">Fabrics</Link></li>
            <li><Link to="/bespoke" className="hover:text-squire-jeanslight">Bespoke</Link></li>
            <li><Link to="/accessories" className="hover:text-squire-jeanslight">Accessories</Link></li>
            <li><Link to="/shop-by-occasion" className="hover:text-squire-jeanslight">Shop by Occasion</Link></li>
          </ul>
        </div>
        <div>
          <div className="sq-eyebrow text-white/60 mb-4">Atelier</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-squire-jeanslight">About</Link></li>
            <li><Link to="/lookbook" className="hover:text-squire-jeanslight">Lookbook</Link></li>
            <li><Link to="/seasonal-spice" className="hover:text-squire-jeanslight">Seasonal Spice</Link></li>
            <li><Link to="/trending-wear" className="hover:text-squire-jeanslight">Trending Wear</Link></li>
            <li><Link to="/marriage-look" className="hover:text-squire-jeanslight">Marriage Look</Link></li>
          </ul>
        </div>
        <div>
          <div className="sq-eyebrow text-white/60 mb-4">Help</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/contact" className="hover:text-squire-jeanslight">Contact</Link></li>
            <li><Link to="/corporate-gifting" className="hover:text-squire-jeanslight">Corporate Gifting</Link></li>
            <li><Link to="/track-order" className="hover:text-squire-jeanslight">Track Order</Link></li>
            <li><Link to="/faq" className="hover:text-squire-jeanslight">FAQs</Link></li>
            <li><Link to="/fabric-compare" className="hover:text-squire-jeanslight">Compare Fabrics</Link></li>
          </ul>
        </div>
      </div>
      <div className="relative border-t border-white/10 py-6 text-center text-xs text-white/50">
        © {new Date().getFullYear()} SquireCouture · All rights reserved · Made in India
      </div>
    </footer>
  );
}
